import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Dropdown/sgds-dropdown";
import { register } from "../../utils/ce-registry";

register("sgds-dropdown", Component);

export default createComponent({
  react: React,
  tagName: "sgds-dropdown",
  elementClass: Component,
  events: {
    onSgdsSelect: "sgds-select",
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
